import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './formLogo.module.scss'

const FormLogo = (props) => {
  const { content, expand, position, ...rest } = props
  return (
    <div
      className={classNames(styles.logoContainer, styles[position])}
      style={{ flexGrow: expand || 'inherit' }}
    >
      <img src={content} className={styles.logo} alt='logo' {...rest} />
    </div>
  )
}

FormLogo.propTypes = {
  content: PropTypes.string.isRequired,
  expand: PropTypes.number,
  position: PropTypes.string
}

export default FormLogo
